import { Link, LinkProps } from "react-router-dom";
import { V2_PAGES_REGEXES } from "utils/versions";

type Props = LinkProps & { to: string }
const VersionSensitiveLink = ({ to, children, ...props }: Props) => {
  return <Link to={to} {...props}>{children}</Link>;
  // for (const regex of V2_PAGES_REGEXES) {
  //   if (to.match(regex)) {
  //     return <Link to={to} {...props}>{children}</Link>;
  //   }
  // }
  // return <a href={`${process.env.REACT_APP_BACKEND_URL}${to}`} {...props}>{children}</a>;
};

export default VersionSensitiveLink;